import * as React from 'react';
import { cn } from '@noor/lib/cn';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        // Figma textarea: 20px radius, 1px #d0d5dd border, field shadow, 140px
        // tall, 14px medium text, 14px medium #98a2b3 placeholder, -0.28px
        // tracking. Disabled fills #f9fafb on #f2f4f7 with #d0d5dd text.
        // Dimensions resolve through `--textarea-*` sizing handles.
        'flex min-h-[var(--textarea-min-height)] w-full rounded-[var(--textarea-radius)] border border-textarea-border bg-transparent px-[var(--textarea-padding-x)] py-[var(--textarea-padding-y)] text-[length:var(--textarea-font-size)] leading-[var(--textarea-line-height)] font-[var(--textarea-font-weight)] tracking-[var(--textarea-tracking)] text-input-fg shadow-field transition-[color,box-shadow] outline-none placeholder:text-[length:var(--textarea-font-size)] placeholder:font-[var(--textarea-placeholder-font-weight)] placeholder:tracking-[var(--textarea-tracking)] placeholder:text-textarea-placeholder disabled:cursor-not-allowed disabled:border-form-control-border-disabled disabled:bg-form-control-bg-disabled disabled:text-form-control-fg-disabled',
        'focus-visible:border-input-border-focus focus-visible:ring-[3px] focus-visible:ring-ring/50',
        'aria-invalid:border-input-border-invalid aria-invalid:ring-input-border-invalid/20',
        'field-sizing-content',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
